module.exports = __webpack_public_path__ + "img/logo.5bab0e7d.svg";